import { createdAtToTimestamp } from './createdAtToTimestamp'
import { getChatSession } from './getChatSession'
import { isAgent } from './isAgent'
import { messageExists } from './messageExists'
import { renderAgent } from './renderAgent'
import { renderChat } from './renderChat'
import { saveChatMessageToSession } from './saveChatMessageToSession'
import { saveChatUserToSession } from './saveChatUserToSession'
import { scrollChatToBottom } from './scrollChatToBottom'

/**
 *
 * @param {LCChatIncomingEvent} payload
 */
export function handleChatIncomingEvent(payload) {
  console.info('incoming event:', payload)

  if (!payload.chatId) {
    console.info('event ignored: no chat id')
    return
  }

  if (
    payload.event.type !== 'message' &&
    payload.event.type !== 'system_message'
  ) {
    console.info('event ignored: not a message')
    return
  }

  if (
    payload.event.type === 'message' &&
    messageExists(payload.event.id || '')
  ) {
    console.info('event ignored: duplicate message')
    return
  }

  if (!payload.event.authorId) {
    console.info('event ignored: no authorId')
    return
  }

  if (payload.event.type === 'message' && !isAgent(payload.event.authorId)) {
    console.info('event ignored: not an agent')
    return
  }

  const authorId = payload.event.authorId
  const id = payload.event.id
  const text = payload.event.text
  const timestamp = createdAtToTimestamp(payload.event.createdAt)

  /** @type {'agent' | 'system'} */
  let authorType = 'agent'

  if (payload.event.type === 'system_message') {
    authorType = 'system'
  }

  saveChatMessageToSession({
    id,
    authorId,
    authorType,
    text,
    timestamp,
  })

  const session = getChatSession()
  const agent = session.users.find((u) => u.id === payload.event.authorId)

  /** @type {LCChatUser} */
  const user = {
    avatar: agent?.avatar || '',
    id: agent?.id || authorId,
    name: agent?.name || 'agent',
    type: 'agent',
  }

  if (!agent) {
    saveChatUserToSession(user)
  }

  renderChat()
  scrollChatToBottom()

  renderAgent(user.name || 'agent', user.avatar || '')
}
